import * as myTreeIcons from "../../images/icons/treeicons";
import { ModuleTypes, kamerItem, TreeIOs } from "../../Shared/sharedInterfaces";
/*
export function checkMod(type: string) {
  let found: boolean = false;
  let parent: number = 0;

  const dbMods: ModuleTypes[] = JSON.parse(
    sessionStorage.getItem("DbModules") || "{}"
  );
  if (dbMods) {
    dbMods.forEach((mod: ModuleTypes) => {
      if (mod.type === type) {
        found = true;
        parent = mod.parentModule;
      }
    });
  }
  const retMod = { found: found, parentModule: parent };
  return retMod;
}
*/

function getDbModules(): ModuleTypes[] {
  try {
    return JSON.parse(sessionStorage.getItem("DbModules") || "[]");
  } catch {
    return [];
  }
}

function normalizeText(value: string): string {
  return String(value || "").trim().toUpperCase();
}

function getTypeBase(type: string): string {
  return String(type || "").split("/")[0];
}

function resolveModule(typeOrName: string): ModuleTypes | undefined {
  const candidate = normalizeText(typeOrName);
  if (!candidate) {
    return undefined;
  }

  const modules = getDbModules();

  const exactType = modules.find((m) => normalizeText(m.type) === candidate);
  if (exactType) {
    return exactType;
  }

  const baseType = modules.find((m) => normalizeText(getTypeBase(m.type)) === candidate);
  if (baseType) {
    return baseType;
  }

  return modules.find((m) => normalizeText(m.name) === candidate);
}

export function checkMod(type: string) {
  const mod = resolveModule(type);

  if (!mod) {
    return { found: false, parentModule: 0, moduleType: "" };
  }

  return { found: true, parentModule: mod.parentModule, moduleType: mod.type };
}

export function getIosOnMod(name: string): Number {
  const mod = getDbModules().find((m) => m.name === name);
  if (!mod) {
    return 0;
  }
  return mod.outputs;
}

// Get all SWC by uitvoering from database
function getSwcs(uitvoering: string) {
  const swcMods: ModuleTypes[] = getDbModules().filter((mod: ModuleTypes) => {
    const parts = mod.type?.split("/");
    
    return mod.type?.includes("SWC") && parts?.[parts.length - 1] === uitvoering && mod.obsolete === 0;
  });
  return swcMods;
}

// Re-build the Input tree, only keep SWCs by uitvoering
export function buildInputsByUitvoering(
  uitvoering: string,
  inputItems: kamerItem[],
) {
  const swcMods: ModuleTypes[] = getSwcs(uitvoering);

  const normalizeModuleType = (moduleType: string, modType: string): string => {
    const suffix = modType.split("/")[1];
    if (suffix === "NNB") {
      if (["SWC01", "SWC02"].includes(moduleType)) return "SWC0102";
      if (["SWC01T", "SWC02T"].includes(moduleType)) return "SWC0102T";
    }

    return moduleType;
  };

  const matchedItems = inputItems.filter(
    (item) =>
      typeof item.moduleType === "string" &&
      swcMods.some(
        (mod) =>
          normalizeModuleType(item.moduleType!, mod.type) ===
          mod.type.split("/")[0],
      ),
  );

  const finalItems = inputItems.filter(
    (item) => item.parent !== "100" || matchedItems.includes(item),
  );

  return finalItems;
}

// NEW: Re-build the Input tree, only keep SWCs by uitvoering
export function newBuildInputsByUitvoering(
  uitvoering: string,
  inputItems: TreeIOs[],
) {
  const swcMods: ModuleTypes[] = getSwcs(uitvoering);

  const normalizeModuleType = (moduleType: string, modType: string): string => {
    
    const suffix = modType.split("/")[1];
    if (suffix === "NNB") {
      if (["SWC01", "SWC02"].includes(moduleType)) return "SWC0102";
      if (["SWC01T", "SWC02T"].includes(moduleType)) return "SWC0102T";
    }

    return moduleType;
  };

  const matchedItems = inputItems.filter(
    (item) =>
      typeof item.moduleType === "string" &&
      swcMods.some(
        (mod) =>
          normalizeModuleType(item.moduleType!, mod.type) ===
          mod.type.split("/")[0],
      ),
  );
/*
  const swcItems: kamerItem[] = matchedItems.map((item) => ({
    id: item.id.toString(),
    name: item.label,
    parent: item.parent,
    nodeid: item.nodeid,
    label: item.label,
    type: item.type,
    typeIcon: item.typeIcon,
    moduleType: item.moduleType,
  }));
*/
  const kamerItems: kamerItem[] = inputItems.map((item) => ({
    id: item.id.toString(),
    name: item.label,
    parent: item.parent,
    nodeid: item.nodeid,
    label: item.label,
    type: item.type,
    typeIcon: item.typeIcon,
    moduleType: item.moduleType,
  }));

  // Filter kameritems, so that finalItems only has SWC's of selected type
  const matchedNodeIds = new Set(matchedItems.map((item) => item.nodeid));
  const finalItems = kamerItems.filter(
    (item) => item.parent !== "090" || matchedNodeIds.has(item.nodeid),
  );

  return finalItems;
}

// Get a module by its id
export function getModById(id: number): ModuleTypes {
  const mod = getDbModules().find((m) => m.id === id);
  if (!mod) {
    throw new Error(`Module with id ${id} not found`);
  }
  return mod;
}



export function checkParentInDb(parentid: number) {
  const typeToCheck = getModById(parentid);
  const offerteDb = JSON.parse(
    sessionStorage.getItem("offerteModules") || "{}",
  );
  if (Object.keys(offerteDb).length > 0) {
    offerteDb.mods.forEach((offerteDbMod: any) => {
      if (offerteDbMod.modType === typeToCheck) {
        offerteDbMod.vrij = offerteDbMod.vrij - 1;
      }
    });
  }
  sessionStorage.setItem("offerteModules", JSON.stringify(offerteDb));
}
